import script from "./MainTable1.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainTable1.vue?vue&type=script&setup=true&lang=ts"

import "./MainTable1.vue?vue&type=style&index=0&id=bb520a7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb520a7a"]])

export default __exports__